<template src="./ActividadTabla.html"></template>

<script>
import {Button, Divider, Pagination, Table, TableColumn, Tag, Tooltip} from 'element-ui'
import {requestAfiliacionMixin} from "@/api/ciudadano/afiliacionApi"
import {mapState} from "vuex";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import moment from "moment";
import {TableMixin} from "@/mixins/TableMixin";
import {ActividadCiudadanoEstadoMixin} from "@/mixins/actividadCiudadanoEstado";

export default {
  name: "ActividadTabla",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Tooltip.name]: Tooltip,
    [Pagination.name]: Pagination,
    [Divider.name]: Divider,
    [Tag.name]: Tag,
  },
  mixins: [
    requestAfiliacionMixin,
    ScreenSizeMixin,
    NotifyMixin,
    TableMixin,
    ActividadCiudadanoEstadoMixin
  ],
  data: () => ({
    idAfiliacion: "",
    filter: ['id', 'fechacompleta', 'nombremodulo', 'tipomodulo', 'estado', 'codigoestado']
  }),
  beforeMount() {
    const pagingQuery = {
      currentPage: this.pagination.currentPage,
      pageSize: this.pagination.pageSize,
    }
    this.getList(pagingQuery, true)
  },
  methods: {
    getList(pagingQuery = {}, firstTime = false) {
      this.loading = true
      pagingQuery['compress'] = false
      pagingQuery['fields'] = this.filter

      this.getListaActividad(pagingQuery)
        .then(response => {
          this.$log.debug('getListaActividad', response.data.statusCode)

          if (response.data.statusCode === 200) {
            this.pagination.total = response.data.totalItems || 5
            const data = JSON.parse(response.data.datos)

            this.$log.debug(data)
            this.tableData = data.map(row => {
              const fecha = moment.utc(row.fechacompleta).local()
              row.fechacompleta = fecha.format('DD-MM-YYYY HH:mm')
              row.fecha = fecha.format('DD-MM-YYYY')
              return row
            })
            this.$log.debug(this.tableData)

            this.errored = false
            if (this.tableData.length === 0) {
              if (firstTime) {
                this.showError('No hay solicitudes por su persona, puede presionar el botón refrescar si lo desea.')
              } else {
                this.showWarn('No hay solicitudes de su persona con sus filtros, puede presionar el botón refrescar si lo desea.')
              }
            }
            this.$scrollTo('#tableResumenTramites')
          } else {
            this.errored = true
            this.showError('Ocurrió un error inesperado al cargar los datos')
          }
        })
        .catch(err => {
          this.$log.fatal('getListaActividad', err, err.response, err.request)
          this.errored = true
          this.showError('Ocurrió un error inesperado al cargar los datos')
        })
        .finally(() => {
          this.loading = false
        })
    },
    descargarComprobante(id) {
      this.$log.debug('descargarComprobante', id)
      this.$emit('on-descarga-comprobante', id)
    },
    onView(id, tipoCodigo, module) {
      this.$log.debug('onView', id, tipoCodigo, module)
      this.$emit('on-view', id, tipoCodigo, module)
    },
    onUndo(id) {
      this.$log.debug('onUndo', id)
      this.$emit('on-undo', id)
    },
    refreshTabla() {
      if (!this.loading) {
        this.querySearch = ''
        this.tableData = []
        this.getList()
      }
    },
    exportExcel() {
      this.$log.debug('onExportExcel', this.querySearch)
      this.$emit('on-export-excel', this.querySearch)
    },
    enterQuery() {
      this.$log.debug('enter input search', this.querySearch)
      this.searchQueryEnter(this.querySearch)
    },
  },
  computed: {
    perPage() {
      return parseInt(this.parametro.params.afiliacionpaginacion) || 5
    },
    ...mapState({
      parametro: state => state.parametro
    }),
  },
}

</script>
